module.exports = __webpack_public_path__ + "img/object-group.52c77136.svg";